import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductListFascade } from '../../fascades/product-list.fascade';

/**
 * window.orderbump_products is set by
 * orderform-assets extension
 */
const INIT_ORDERBUMP_PRODUCT_IDS: number[] =
  // @ts-ignore
  window.orderbump_products || [];

@Injectable({ providedIn: 'root' })
export class OrderBumpService {
  /**
   * Component can be exists with no product selected
   */
  private _orderBumpProductIdList$ = new BehaviorSubject<number[]>([
    ...INIT_ORDERBUMP_PRODUCT_IDS,
  ]);

  /**
   * Return unique list of productIds which is set in orderbumps
   */
  public productIdList$ = this._orderBumpProductIdList$.asObservable().pipe(
    map((data) => {
      const uniqueSet = new Set<number>([...data]);
      return Array.from(uniqueSet);
    })
  );

  constructor(private _productListFascade: ProductListFascade) {}

  /**
   * Simply add product to the stack
   * @param productId
   */
  addProductId(productId: string) {
    const values = [...this._orderBumpProductIdList$.value];
    values.push(+productId);
    this._orderBumpProductIdList$.next(values);
  }

  /**
   * Remove product id from stack of product Ids in orderbumps
   * @param productId
   */
  removeProductId(productId: string) {
    const values = [...this._orderBumpProductIdList$.value];
    const findIndex = values.indexOf(+productId);
    if (findIndex > -1) {
      values.splice(findIndex, 1);
    }
    this._orderBumpProductIdList$.next(values);
  }

  getProductById(productId: string) {
    return this._productListFascade.cartProductList$.pipe(
      map((list) => list.find((product) => +productId === +product.product_id))
    );
  }
}
